import React, { useState } from 'react';
import { ButtonIcon } from '@components/Button';
import { useTranslation } from 'next-i18next';

type AccordionProps = {
  title: string;
  children?: React.ReactNode | null;
};

export const AccordionList: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <dl className={`accordion ${className}`} role="presentation">
    {children}
  </dl>
);

const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
}: AccordionProps) => {
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);
  const icon = open ? 'arrow-up' : 'arrow-down';
  const text = open ? t('close') : t('open');

  return (
    <>
      <dt className="accordion-header" data-opened={open}>
        <span className="accordion-title">{title}</span>
        {children && (
          <ButtonIcon onClick={() => setOpen(!open)} icon={icon} text={text} />
        )}{' '}
      </dt>
      {children && <dd className="accordion-description">{children}</dd>}{' '}
    </>
  );
};

export default Accordion;
